module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-34.a16e1faa.png";